import { getSummary } from "./actions/getSummary";

export const actions = {
    getSummary
};